import { render, staticRenderFns } from "./add-score-modal.vue?vue&type=template&id=67cab193"
import script from "./add-score-modal.vue?vue&type=script&lang=js"
export * from "./add-score-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports